module.exports = __webpack_public_path__ + "38c3820ce725cc081f1fc3b8ccdf4c17.png";